<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">

      <!-- Autorisation de pratique -->
      <fieldset>
        <legend class="text-h6 text-sm-h5">Autorisation de pratique</legend>
        <div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Pour quelle autorisation faites-vous une demande ? Veuillez sélectionner :</th>
                <th class="text-right">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item) in listeAutorisationsDePratique.filter(a => (a.demandeAdmission && a.demandeAdmission.length > 0))"
                  :key="item.name"
                  :class="{'red lighten-3': item.statut != null && item.statut.id === $catalogues.statutAutorisationDePatique.retire}">
                <td class="pt-4">
                  <v-autocomplete v-if="isNew(item) && isNotRetire(item)"
                                  v-model="item.categorieAutorisation"
                                  :item-text="itemText"
                                  :item-value="itemValue"
                                  :items="listeCategoriesAutorisationsFilter"
                                  :rules="rules.categorieAutorisation"
                                  label="Catégorie d'autorisation"
                                  required
                                  return-object></v-autocomplete>
                  <v-autocomplete v-if="!isNew(item) && isNotRetire(item)"
                                  v-model="item.categorieAutorisation"
                                  :item-text="itemText"
                                  :item-value="itemValue"
                                  :items="listeCategories"
                                  :rules="rules.categorieAutorisation"
                                  disabled
                                  label="Catégorie d'autorisation"
                                  readonly
                                  required
                                  return-object></v-autocomplete>
                </td>
                <td class="text-right pt-4">
                  <v-btn v-if="item.statut != null && item.statut.id === $catalogues.statutAutorisationDePatique.retire"
                         color="primary"
                         icon
                         @click="addRow(item)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <template>
            <div class="text-center mt-6 d-flex justify-lg-flex-end">
              <v-btn :disabled='!canAdd' color="primary" @click="ajouter()">ajouter</v-btn>
            </div>
          </template>
        </div>
      </fieldset>

      <fieldset v-if="legalSpecial" class="legalSection">
        <legend class="text-h6 text-sm-h5">Conditions et critères</legend>
        <section class="mentionLegal">
          L'autorisation spéciale temporaire <b>s'adresse aux personnes qui répondent aux conditions d'admissibilité</b>
          suivantes :
          <ol>
            <li> Être titulaire d'un baccalauréat ou d'une maîtrise en T.S. ou d'une maîtrise en T.C.F. OU</li>
            <li> Être légalement autorisé à exercer la profession de travailleur social ou de thérapeute conjugal et
              familial hors du Québec (titulaire d'un permis) et être en règle avec l'organisme ayant délivré
              l'autorisation d'exercice OU
            </li>
            <li> Être invité par un établissement, une université ou un autre organisme dans le but d'apprendre ou
              d'enseigner des activités réservées OU
            </li>
            <li> Être invité par un établissement, une université ou un autre organisme dans le but d'exercer de façon
              ponctuelle auprès d'une personne ou d'un groupe de personnes ciblées;
            </li>
            <li> Être amené à offrir temporairement des services au Québec.</li>
            <li> L'autorisation spéciale est valable pour une période d'un an ou moins (selon la durée recherchée).</li>
          </ol>
          <br />
          <p class="font-italic">Attention : lorsqu'un candidat est invité à venir au Québec pour donner des services à la
            population, la voie à favoriser est celle du permis d'exercice. Pour la personne légalement autorisée à
            exercer hors Québec et qui est par ailleurs titulaire d'un permis d'exercice au Québec sans être inscrit au
            tableau de l'Ordre, <b>la réinscription au tableau de l'Ordre doit être privilégiée.</b></p>
          <p>Retrouver plus d'informations sur
            <a href="https://www1.otstcfq.org/exercer-au-quebec/exercer-au-quebec/admission-et-inscription/autorisation-speciale-temporaire/"
               target="_blank">l'autorisation spéciale temporaire</a> sur notre site internet.</p>
        </section>
      </fieldset>

      <fieldset v-if="legalEtudiant" class="legalSection">
        <legend class="text-h6 text-sm-h5">Condition étudiant</legend>
        <p class="mentionLegal">
          Une inscription à ce registre permet l'exercice, par des étudiants inscrits aux programmes universitaires du
          Québec, de certaines activités professionnelles réservées aux membres de l'Ordre dans le cadre d'un emploi
          rémunéré et sous supervision.<br>
          <br />
          Cette autorisation temporaire prendra fin à la première occurrence, soit l'obtention du grade donnant accès au
          permis de l'Ordre, la fin du contrat de travail ou l'abandon du programme d'études.
          <br />
          Retrouver plus d'information sur
          <a href="https://www1.otstcfq.org/exercer-au-quebec/exercer-au-quebec/admission-et-inscription/registre-des-etudiants/"
             target="_blank">le registre des étudiants</a> sur notre site internet.
        </p>
      </fieldset>

    </v-form>

    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid"
             color="secondary"
             @click="saveAndContinueLater()">Enregistrer et terminer plus tard
      </v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">
        Suivant
      </v-btn>

      <v-dialog v-model="dialog"
                max-width="350"
                persistent>
        <v-card>
          <v-card-title class="headline">
            Attention
          </v-card-title>
          <v-card-text class="subtitle-1">Je comprends qu'en validant ce formulaire sans autorisation de pratique, je
            serai retiré du tableau de l'ordre.
          </v-card-text>
          <v-card-actions>
            <v-btn color="error"
                   text
                   @click="dialog = false">
              Annuler
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   text
                   @click="processRetraitVolontaire">
              Je suis d'accord
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAjout"
                max-width="50%"
                persistent>
        <v-card>
          <v-card-title class="headline">
            Attention
          </v-card-title>
          <v-card-text class="subtitle-1">
            Si vous avez déjà été travailleur social ou thérapeute conjugal et familial, utilisez le formulaire de
            réadmission.<br />
            Si vous avez déjà commencé à remplir un formulaire d'admission, vous devez le reprendre avec le lien qui
            vous a été communiqué par courriel.<br />
            Pour toutes questions, merci de contacter le service à la clientèle.
          </v-card-text>
          <v-card-actions>
            <v-btn color="error"
                   text
                   @click="dialogAjout = false">
              Retour
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Loader from "../Loader"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"

export default {
  mixins: [
    NavigationPageFormulaireMixin,
    PageReadonlyFormulaireAdmissionMixin
  ],
  components: {
    Loader: Loader,
  },
  props: {
    routeName: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      rules: {
        CategorieAutorisation: [
          (v) => (!!v && v.length != 0) || "Le type d'autorisation est requis",
        ],
        Autorisation: [
          (v) => (!!v && v.length != 0) || "L'autorisation est requise",
        ],
      },
      dialog: false,
      dialogAjout: false,
    }
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      getAutorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      listeCategories: "Catalogue/GET_CATEGORIEAUTORISATION",
    }),
    legalSpecial () {
      return (
          this.getAutorisations &&
          this.getAutorisations.find(
              (t) => t.categorieAutorisation && t.categorieAutorisation.id == this.$catalogues.categorieAutorisation.autorisationSpeciale
          )
      )
    },
    legalEtudiant () {
      return (
          this.getAutorisations &&
          this.getAutorisations.some(
              (t) => t.categorieAutorisation && t.categorieAutorisation.id == this.$catalogues.categorieAutorisation.registreDesEtudiants
                  && t.statut == null
          )
      )
    },
    canAdd () {
      let result =
          this.getAutorisations &&
          this.getAutorisations.some(
              (a) => a.demandeAdmission == this.demandeAdmissionId
          )

      return !result
    },
    listeAutorisationsDePratique () {
      return this.getAutorisations.filter(a => a.demandeAdmission == this.demandeAdmissionId)
    },
    listeCategoriesAutorisationsFilter () {
      return this.listeCategories.filter(c =>
          (c.id == this.$catalogues.categorieAutorisation.travailleurSocial ||
              c.id == this.$catalogues.categorieAutorisation.therapieConjugaleFamiliale) &&
          !this.getAutorisations.filter(a => (a.statut != null || a.autorisation != null) && a.demandeAdmission != this.demandeAdmissionId)
              .map((autorisation) => autorisation.categorieAutorisation.id)
              .includes(c.id))
          .sort((a, b) => (a.lang00 < b.lang00) ? 1 : -1)
    }
  },
  created () {
    this.fetchItems()
  },
  methods: {
    ...mapMutations({
      addAutorisationDePratique:
          "AutorisationDePratique/ADD_AUTORISATIONDEPRATIQUE",
      removeAutorisationDePratique:
          "AutorisationDePratique/REMOVE_AUTORISATIONDEPRATIQUE",
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getAutorisationDePratiqueByContactId: "AutorisationDePratique/getAutorisationDePratiqueByContactId",
      updateAutorisationDePratique: "AutorisationDePratique/updateAutorisationDePratique",
      createAutorisationDePratique: "AutorisationDePratique/createAutorisationDePratique",
      deleteAutorisationDePratique: "AutorisationDePratique/deleteAutorisationDePratique",
      retraitVolontaire: "DemandeInscription/retraitVolontaire",
      demandeTerminee: "DemandeInscription/demandeTerminee",
    }),
    async fetchItems () {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.categorieAutorisation),
          this.getCatalogue(this.$cataloguesDesc.membreAutresOrdres),
          this.getCatalogue(this.$cataloguesDesc.instancesReglementaires),
        ]

        if (this.demandeAdmissionPpId) {
          requests.push(this.getAutorisationDePratiqueByContactId(this.demandeAdmissionPpId))
        }

        await Promise.all(requests)

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    saveAndContinue () {
      this.redirectValue = "continue"

      if (this.readonly) {
        return this.redirect()
      }

      if (this.listeAutorisationsDePratique.filter(a => (a.statut && a.statut.id !== this.$catalogues.statutAutorisationDePatique.retire)).length == 0 &&
          this.listeAutorisationsDePratique.filter(a => a.statut == null || a.statut.id !== this.$catalogues.statutAutorisationDePatique.retire).length == 0) {
        this.dialog = true
      } else {
        this.save()
      }
    },
    async save () {
      this.$refs.form.validate()
      if (!(this.valid && this.listeAutorisationsDePratique)) {
        return
      }

      this.messageSelector = "Save"
      this.overlay = true

      // Autorisation de pratique
      const autorisationATraiter = this.getAutorisations.filter(a => a.demandeAdmission == null || a.demandeAdmission == this.demandeAdmissionId)

      if (autorisationATraiter && autorisationATraiter.length > 0) {

        for (const element of autorisationATraiter) {
          if (element.id == '' || element.id == null) {
            if (this.demandeAdmissionId) {
              element.demandeAdmission = this.demandeAdmissionId
            }
            await this.createAutorisationDePratique(element)
          } else {
            await this.updateAutorisationDePratique(element)
          }
        }
      }

      this.overlay = false
      this.redirect()

    },
    ajouter () {
      if (this.listeCategoriesAutorisationsFilter && this.listeCategoriesAutorisationsFilter[0]) {
        this.addAutorisationDePratique({
          id: null,
          pp: this.demandeAdmissionPpId,
          demandeAdmission: this.demandeAdmissionId,
          categorieAutorisation: this.listeCategoriesAutorisationsFilter[0],
          autorisation: null,
          statut: null,
          deleted: false,
        })
      } else {
        this.dialogAjout = true
      }
    },
    addRow (item) {
      item.statut.id = this.$catalogues.statutAutorisationDePatique.membre
      this.updateAutorisationDePratique(item)
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    isNotRetire (item) {
      return (
          !(item.statut === this.$catalogues.statutAutorisationDePatique.retire && item.deleted == null)
      )
    },
    validateForm (resetValidation = false) {
      this.valid = (this.$refs.form?.validate() || false)
      && (this.getAutorisations || this.getAutorisations.length == 0)

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    isNew (item) {
      return (
          (!this.demandeAdmissionId || item.demandeAdmission == this.demandeAdmissionId)
      )
    },
    async processRetraitVolontaire () {
      for (const element of this.getAutorisations) {
        await this.updateAutorisationDePratique(element)
      }

      await this.retraitVolontaire()
      await this.demandeTerminee()

      await this.$router.push({
        name: `DemandeInscription/RetraitVolontaire`
      })
    },
  },
}
</script>

<style>
</style>